import React, { useRef } from 'react';

import { Select } from '@aline/common';
import { IconButton } from '@mui/material';
import { AlineTooltip, useWorkflowReadOnlyContext } from 'src/components';
import { AddIcon } from 'src/components/icons/AddIcon';
import { tooltipMsg } from 'src/helpers';
import { useAreWorkflowStepsEditable, useCheckWorkflowAuthorization } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  iconCircle: {
    marginLeft: theme.spacing(1),
  },
  text: {
    margin: theme.spacing(0, 1),
  },
  wrapper: {
    alignItems: 'center',
    alignSelf: 'flex-start',
    display: 'flex',
  },
}));

interface ActionGroupHeaderSectionProps {
  setNewActionRow: (open: boolean) => void;
  workflowId: UUID;
}

export function SigningGroupHeaderSection({
  setNewActionRow,
  workflowId,
}: ActionGroupHeaderSectionProps): JSX.Element | null {
  const { classes } = useStyles();
  const { isReadOnly } = useWorkflowReadOnlyContext();
  const addIconRef = useRef<HTMLButtonElement | null>(null);
  const { areStepsEditable } = useAreWorkflowStepsEditable(workflowId);
  const { canEditWorkflow } = useCheckWorkflowAuthorization(workflowId);
  const disabledReason = isReadOnly
    ? tooltipMsg.wFIsReadOnly
    : !canEditWorkflow
      ? tooltipMsg.notWFEditor
      : !areStepsEditable
        ? tooltipMsg.recipientNotEditable
        : '';

  if (isReadOnly) return null;

  return (
    <div className={classes.wrapper}>
      {areStepsEditable && (
        <AlineTooltip arrow placement="top" title={disabledReason || 'Add action'}>
          <div>
            <IconButton
              ref={addIconRef}
              aria-label="Add new action"
              data-cy={Select.workflow.detail.step.addNewActionButton}
              disabled={Boolean(disabledReason)}
              size="small"
              onClick={() => setNewActionRow(true)}
            >
              <AddIcon />
            </IconButton>
          </div>
        </AlineTooltip>
      )}
    </div>
  );
}
